// extracted by mini-css-extract-plugin
module.exports = {"xs_only":"only screen and (max-width: 767px)","sm_only":"only screen and (min-width: 768px) and (max-width: 991px)","container":"no_results_overlay_generic__container__gS2yZ"};